import React, { Fragment } from 'react';
//import { useReactToPrint } from 'react-to-print';
//import {useLocation} from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
//import { ContentTitle } from '../../ui/styled';
//import { Auth } from 'aws-amplify';
import BackIcon from '../common/Back/BackIcon';
//import { ContentTitle } from '../ui/styled';
import { dateFormatShort } from '../../constants';
import moment from 'moment';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

//import { LeftGrid } from '../Episode/Episode.Styled';
//import Button from '@mui/material/Button';

const PopSheetPdfTable = (props) => {
  const { name, cols, rows } = props;
  
  console.log('### name');
  console.log(name);

  console.log('### cols');
  console.log(cols);

  console.log('### rows');
  console.log(rows);
  
  return (
    <Box p={2}>
      <Box style={{ alignItems: 'center' }}>
        <Typography variant='h5' align='center'>Pop Sheet</Typography>
      </Box>
      <Grid item xs={12}>
        <Box p={2} style={{ alignItems: 'center' }}>
          <Typography variant='h5'>{name}</Typography>
        </Box>
      </Grid>

      <TableContainer component={Paper}>
        <Table sx={{  }} aria-label="simple table">
          <TableHead>
            <TableRow
              sx={{backgroundColor: '#000'}}
            >
              {
                cols.map((col, index) => {
                  return (
                    <Fragment key={index}>
                      <TableCell sx={{color: '#fff', fontSize: '10px'}}>{col.headerName}</TableCell>
                    </Fragment>  
                  );
                })
              }
            </TableRow>  
          </TableHead>
          {
            rows.map((row, index) => {
              return(
                <Fragment key={index}>
                  <TableRow
                    sx={{ '&:nth-of-type(odd)': {backgroundColor: '#eee'}, '&:last-child td, &:last-child th': { border: 0} }}
                  >
                    {
                      cols.map((col) => {
                        return (
                          <TableCell sx={{fontSize: '10px'}}>
                            {
                              col.headerName.includes('Date') && row[col.field] ? moment(row[col.field]).format(dateFormatShort) :
                              col.headerName.includes('180') ? moment(row['sapAthOvrlEndDate']).add(180, 'd').format(dateFormatShort) : 
                              row[col.field]}
                          </TableCell>
                        );
                      })
                    }
                  </TableRow>  
                </Fragment>  
              )
            })                    
          }
        </Table>
      </TableContainer>
    </Box>      
  ); 

};
export default PopSheetPdfTable;

